export default __webpack_public_path__ + "static/media/012-Golden Gate Bridge.1dfc12ee.svg";